import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';



function CircularProgressWithLabel(props) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant="determinate" {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
};

const MyScore = (props) => {
    return (
        <div className="prgrs-cmpnnt">
            <div className="progress">
                <CircularProgressWithLabel value={props.progress} />
                <span>جمع کل امتیازات</span>
                <strong>{(props.data.plusScores - props.data.minusScores) || 0}</strong>
                <div className="progress-bar"></div>
            </div>
            <div className="awareded-scores">
                <div className="scores">
                    <span className="scoreNumber"><img src="/icons/max.svg" />{props.data == undefined ? '' : props.data.plusScores}</span>
                    <span>امتیازات کسب شده</span>
                </div>
                <div className="scores">
                    <span className="scoreNumber" tart><img src="/icons/min.svg" />{props.data == undefined ? '' : props.data.minusScores}</span>
                    <span>امتیازات خرج شده</span>
                </div>
            </div>
            <Link to="/MyScores" className="link">جزئیات بیشتر</Link>
        </div>
    );
}

export default MyScore;